import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService } from 'app/core';
import { TaskListTemplate } from 'app/shared/modules/legacy-tasks/tasks.types';
import { LegacyTasksTabService } from '@shared/modules/legacy-tasks/services/tasks.service';
import { Store } from '@ngxs/store';
import { TaskActions } from '@tasks/state/actions';
import { RelatedToType } from '@shared/enums';
import { AccountState } from '@state/account/state';
import { TaskListTemplateService } from '@tasks/services/task-list-template.service';

@Injectable({
  providedIn: 'root',
})
export class TaskListTemplatesTaskListTemplateResolver {
  constructor(
    private readonly _router: Router,
    private readonly tasksService: TaskListTemplateService,
    private readonly store: Store,
  ) {
    const accountId = +this.store.selectSnapshot(AccountState.getAccount)?.id;
    this.store.dispatch(new TaskActions.SetRelatedTo(RelatedToType.Account, accountId));
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TaskListTemplate> {
    return this.tasksService.getTaskListTemplateById(+route.paramMap.get('id')).pipe(
      catchError((error) => {
        const parentUrl = state.url.split('/').slice(0, -1).join('/');
        this._router.navigateByUrl(parentUrl);
        return throwError(() => new Error(error));
      }),
    );
  }
}
